export enum EventType {
  NewConversation = 'NewConversation',
  NewPhoto = 'NewPhoto',
  UserInput = 'UserInput',
}

export interface AudioMessage {
  sessionId: string;
  audio: Blob | null;
  photoId: string | null;
  eventType: EventType | null;
}
